@if (!multiSelection()) {
  <ISelectMenu
    [value]="selectedMarketplaceOption()"
    (valueChange)="selectMarketplace($event)"
    [(searchQuery)]="searchQuery"
  >
    <ISelectTrigger>
      <ISelectValue>
        <div *iSelectValue="let value" class="flex items-center gap-2">
          <app-marketplace-option [marketplace]="value" [isLabel]="true" />
        </div>
      </ISelectValue>
    </ISelectTrigger>
    <ISelectContent>
      @for (marketplace of filteredMarketplaceOptions(); track marketplace.marketplace) {
        <ISelectOption [value]="marketplace">
          <div class="flex items-center gap-2 truncate text-sm text-gray-600">
            <app-marketplace-option [marketplace]="marketplace" />
          </div>
        </ISelectOption>
      }
    </ISelectContent>
  </ISelectMenu>
} @else {
  <IMultiSelectMenu
    [value]="selectedMarketplacesOptions()"
    (valueChange)="selectMarketplaces($event ?? [])"
    [(searchQuery)]="searchQuery"
    popoverWidth="250"
    withSelectOnly
  >
    <ISelectTrigger>
      <ISelectValue>
        <div *iSelectValue="let value" class="flex items-center gap-1">
          @if (value.length === 1) {
            <app-marketplace-option [marketplace]="value[0]" [isLabel]="true" />
          } @else {
            <span class="text-gray-800">{{ selectedMarketplacesLabel() }}</span>
          }
        </div>
      </ISelectValue>
    </ISelectTrigger>
    <ISelectContent>
      @if (filteredMarketplaceOptions().length > 1) {
        <ISelectOption selectAllOption />
        <IDropdownMenuSeparator />
      }
      @for (marketplace of filteredMarketplaceOptions(); track marketplace.marketplace) {
        <ISelectOption [value]="marketplace">
          <div class="flex items-center gap-2 truncate text-sm text-gray-600">
            <app-marketplace-option [marketplace]="marketplace" />
          </div>
        </ISelectOption>
      }
    </ISelectContent>
  </IMultiSelectMenu>
}
